import { TextArea, FormItem } from '@idaho-aeyc/ui-kit';
import { useTranslation } from '@packages/utils';
import useGetValidationData from 'components/Base/Form/validationRules';
import { CUSTOM_QUESTION_TRANSLATE_KEY } from 'components/Shared/RegisterAction/RegistrationModal/RegistrationModalForm/CustomQuestion/CustomQuestion.data';
import useRegistrationContext from '../../../context/NewRegistrationModalContext';

const QuestionSection = () => {
  const { validationRules } = useGetValidationData({
    lng: 'translate',
  });
  const { t } = useTranslation({
    keyPrefix: CUSTOM_QUESTION_TRANSLATE_KEY,
    lng: 'translate',
  });

  const { eventDetails } = useRegistrationContext();

  return (
    <>
      <h2>{t('TITLE')}</h2>
      <FormItem
        name="customQuestionAnswer"
        rules={[validationRules.requiredField()]}
        label={eventDetails?.customQuestion}
        data-cy="registration-custom-question"
      >
        <TextArea
          maxLength={144}
          showCount
          placeholder={t('form.placeholder')}
        />
      </FormItem>
    </>
  );
};

export default QuestionSection;
